import { render, staticRenderFns } from "./VehiclesComponent.vue?vue&type=template&id=50c5eaca&scoped=true&"
import script from "./VehiclesComponent.vue?vue&type=script&lang=ts&"
export * from "./VehiclesComponent.vue?vue&type=script&lang=ts&"
import style0 from "./VehiclesComponent.vue?vue&type=style&index=0&id=50c5eaca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c5eaca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VHover,VRow})
